import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Material } from '@classes/material';
import { MaterialGridViewItem } from '@classes/material-grid-view-item';
import { MessageBoxParameter } from '@classes/message-box-parameter';
import { MessageBox } from '@components/message-box/message-box.component';
import { Role } from '@enums/role.enum';
import { TranslateService } from '@ngx-translate/core';
import { MaterialService } from 'app/core/services/material.service';
import { UiService } from 'app/core/services/ui.service';
import { MaterialDetailComponent } from '../material-detail/material-detail.component';

@Component({
  selector: 'app-materials-grid',
  templateUrl: './materials-grid.component.html',
  styleUrls: ['./materials-grid.component.scss']
})
export class MaterialsGridComponent implements OnInit, AfterViewInit {


  @Input() set filter(filter: string) {
    this.dataSource.filter = filter;
  };

  dataSource = new MatTableDataSource<MaterialGridViewItem>();
  pageSizeOptions = [25, 50, 100];
  selectedRowID: string;
  displayedColumns: string[] = [
    'name',
    'dangerousLevel',
    'modifiedDate',
    'userName',
    'action'
  ];

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) MatPaginatorMaterials: MatPaginator;

  Role = Role;

  constructor(
    public materialService: MaterialService,
    public uiService: UiService,
    public dialog: MatDialog,
    public translateService: TranslateService
  ) { }

  ngOnInit() {
    this.getMaterials();
  }

  getMaterials() {
    this.uiService.addRouteLoading();
    this.materialService.getMaterials(true).subscribe(materials => {
      this.dataSource.data = materials.map(m => new MaterialGridViewItem({
        id: m.id,
        name: m.name,
        modifiedDate: m.modifiedDate ? m.modifiedDate : (m.creationDate ? m.creationDate : null),
        userName: m?.modifiedUser ? (m?.modifiedUser?.firstName + " " + m?.modifiedUser?.lastName) : (m?.creationUser?.firstName + " " + m?.creationUser?.lastName),
        dangerousLevel: m?.dangerousLevel
      }));
      this.uiService.removeRouteLoading();
    }, error => {
      console.error(error);
      this.uiService.removeRouteLoading();
    });
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.MatPaginatorMaterials;
    this.dataSource.sortingDataAccessor = (data: any, sortHeaderId: string): string => {
      if (typeof data[sortHeaderId] === 'string') {
        return data[sortHeaderId].toLocaleLowerCase();
      }

      return data[sortHeaderId];
    };
  }

  selectItemClick(item: MaterialGridViewItem) {
    this.selectedRowID = item.id || '';
  }

  editElement(item: MaterialGridViewItem) {
    const data = new Material({
      id: item.id || "",
      name: item.name || "",
      dangerousLevel: item.dangerousLevel
    });
    const dialogRef = this.dialog.open(MaterialDetailComponent, {
      data,
      hasBackdrop: true
    });
    dialogRef.afterClosed().subscribe(success => {
      if (success) {
        this.getMaterials();
      }
    });
  }

  onDelete(item: MaterialGridViewItem) {
    if (item && item.id) {

      const messageBoxParameter = new MessageBoxParameter();

      messageBoxParameter.message = this.translateService.instant('material.confirm-delete');
      messageBoxParameter.dialog = this.dialog;
      messageBoxParameter.title = 'Confirmation';
      messageBoxParameter.buttons = ['yes', 'no'];
      messageBoxParameter.width = "400px";

      MessageBox.show(messageBoxParameter).subscribe(mbResult => {
        if (mbResult && mbResult.value) {
          this.uiService.addRouteLoading();
          this.materialService.deleteMaterial(item?.id || "").subscribe(data => {
            this.uiService.displayMessageToast('material.success-delete');
            this.uiService.removeRouteLoading();
            this.getMaterials();
          }, error => {
            console.error(error);
            this.uiService.removeRouteLoading();
          });
        }
      });
    }
  }

}
